import React from "react";
import consts from "../../../../shared/consts";
import style from "./widthPicker.module.css";
import { DropdownButton } from "../toolbar-buttons";
import { LineThickness } from "frontend/icons/line-thickness";
import { ButtonRow } from "./toolbar-design-system";
import ToggleButton from "./toggle-button";

export function WidthPicker({
  value,
  onChange,
  tooltip,
  multi,
}: {
  value: string;
  onChange?: any;
  tooltip?: string;
  multi?: boolean;
}) {
  const subMenu = () => {
    return (
      <ButtonRow>
        <ToggleButton
          isOn={!multi && value === consts.WIDTH_SIZES.LARGE}
          onClick={() => onChange && onChange(consts.WIDTH_SIZES.LARGE)}
        >
          <svg className={style.largeWidthIcon} viewBox="0 0 10 10" fill="currentColor">
            <circle cx="5" cy="5" r="5" />
          </svg>{" "}
        </ToggleButton>
        <ToggleButton
          isOn={!multi && value === consts.WIDTH_SIZES.SMALL}
          onClick={() => onChange && onChange(consts.WIDTH_SIZES.SMALL)}
        >
          <svg className={style.smallWidthIcon} viewBox="0 0 4 4" fill="currentColor">
            <circle cx="2" cy="2" r="2" />
          </svg>{" "}
        </ToggleButton>
      </ButtonRow>
    );
  };

  return (
    <DropdownButton tooltip={tooltip} className={style.popupContainer} renderPopup={subMenu}>
      <LineThickness color="white" size={20} />
    </DropdownButton>
  );
}
